<template>
    <div>
        <Loading :show="isLoading"></Loading>
        <div class="modal" :style="{ display: showAlert ? 'block' : 'none' }" style="background: rgba(1,1,1,0.5);">
            <div
                style="background:white;max-width:500px;height: 130px;margin: 80px auto 0px;text-align: center;padding:10px;">
                <h1><span class="glyphicon glyphicon-ok-circle" style="color:green;"> {{ alertMsg }} </span></h1>

                <div class="row">
                    <div class="col-xs-6">
                        <router-link class="btn btn-default" to="/Cart" v-if="hasLogin"><span
                                class="glyphicon glyphicon-shopping-cart"></span> {{ lang.itemDetail.cart
                            }}</router-link>
                        <router-link class="btn btn-default" to="/wishList" v-if="!hasLogin"><span
                                class="glyphicon glyphicon-shopping-cart"></span> {{ lang.navi.wishList }}</router-link>
                    </div>
                    <div class="col-xs-6">
                        <span class="act-close-btn btn btn-default" @click="showAlert = false">{{
            lang.itemDetail.continue
        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:hidden;">
            <combo-slider :slider-data="sliderData"></combo-slider>
        </div>

        <div class="col-xs-12" style="padding:4px;" v-if="item !== null">
            <div style="padding: 4px;text-align: center;border:1px solid #f5f5f5;margin: 4px;">
                <div
                style="font-size: 1.2em; margin:2px 7px;display: inline-flex;flex-direction: row;border: 1px solid gray;padding: 4px;">
                <div style="padding:0px 4px;" class="agx-theme-bg">{{ item.parentCategory.name }}</div>
                <div style="border-left:1px solid gray;padding:0px 8px;">{{ item.category.name }}</div>
            </div>
                
                <div style="font-size:1.8em;font-weight: bolder;"> {{ item.title }}</div>
                <div style="margin-bottom:4px;padding: 4px;display: flex;flex-direction:row;align-items: center; justify-content: center;">
                    <price-tag :item="item"></price-tag>
                    <div v-if="hasPrice" class="btn agx-theme-bg" @click="showAddToCart = true">+
                        {{ lang.itemDetail.select }}</div>
                </div>

            </div>
           

            <div style="font-size:1em;">
                <post-label :item="item"></post-label>
                <post-tag :item="item"></post-tag>
                <div>
                    <div v-for="itemMsg in itemPageMsgs">
                        <div>{{ itemMsg.title }}</div>
                        <div>{{ itemMsg.content }}</div>
                    </div>
                </div>
            </div>

            <div>
                <div class="btn btn-default glyphicon glyphicon-comment" style="float:right;" @click="showQa = true">
                </div>
            </div>

            <div :style="{ display: !showQa ? 'none' : 'block' }" class="modal"
                style="z-index:12345;background:rgba(1,1,1,0.5);margin-top:50px;">
                <div class="col-xs-12" style="text-align:right;">
                    <span class="btn btn-default" @click="showQa = false">X</span>
                </div>
                <div
                    style="width:80%;max-width:400px;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;padding:10px;">
                    <paged-qa v-if="showQa" :to-user-id="item.userId" page-path="ItemDetail" :page-query="item.postId"
                        :api-client="apiClient"></paged-qa>
                </div>
            </div>

            <hr />
        </div>

        <div>

            <!-- Nav tabs -->
            <ul class="nav nav-tabs">
                <li role="presentation" style="cursor:pointer;" @click="showDetail"
                    :class="{ active: inView === 'detail' }"><a @click.prevent>{{ lang.itemDetail.description }}</a>
                </li>
                <li role="presentation" style="cursor:pointer;" @click="showLabels"
                    :class="{ active: inView === 'label' }">
                    <a @click.prevent>{{ lang.itemDetail.specs }}</a>
                </li>
                <li role="presentation" style="cursor:pointer;" @click="showTags" :class="{ active: inView === 'tag' }">
                    <a @click.prevent>{{ lang.itemDetail.tags }}</a>
                </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane active">
                    <div class="row">
                        <div class="col-xs-12">
                            <div style="padding:6px;" :style="{ 'white-space': inView === 'detail' ? 'pre-line' : '' }">
                                <div v-if="item !== null">
                                    <div v-html="html"></div>
                                </div>
                                <div v-if="inView === 'detail'">
                                    <div class="row" style="margin:10px;">
                                        <div class="col-xs-12" v-if="videos.length > 0"
                                            style="background: #f5f5f5;border-radius: 10px; ">
                                            <div class="col-xs-12" :class="{ 'col-md-6': videos.length > 1 }"
                                                v-for="link in videos"
                                                style="padding-left: 0px; padding-right: 0px; background: #f5f5f5;border-radius: 10px; ">
                                                <div style="display: inline-block;width:100%; ">
                                                    <media-link :item="link"></media-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" style="margin:10px;">
                                        <div :class="{ 'col-xs-12': links !== null && links.length === 1, 'col-sm-6 col-md-6': links !== null && links.length > 1 }"
                                            v-for="link in links"
                                            style="border-radius: 10px; border: 1px solid white; height: 140px;">
                                            <dual-link :item="link" target="_self"></dual-link>
                                        </div>
                                    </div>

                                    <paged-infos
                                        :init-filter="{ prid: postId, cardView: 'mediaStack', pageSize: 3, hidePaging: true }"></paged-infos>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <modal-x :show="showAddToCart" @onclose="showAddToCart = false"
            :contentStyle="{ 'max-width': '600px', height: '80%' }" :modal-style="{ 'margin-top': '50px' }">
            <add-to-cart :post-id="item.postId" v-if="showAddToCart" @ondone="showAddToCart = false"
                :title="item.title"></add-to-cart>
        </modal-x>
    </div>
</template>
<script>
import Loading from './base/Loading.vue';
import comboSlider from './slider/Combo.vue';
import PagedQa from './PagedQA.vue';
import PagedInfos from './PagedInfos.vue';
import modalX from './base/ModalX1.vue';
import addToCart from './AddToCart.vue';
import DualLink from './links/dualLink.vue';
import mediaLink from './links/mediaLink.vue';
import PriceTag from './PriceTag.vue';
import PostTag from './PostTag.vue';
import PostLabel from './PostLabel.vue';
export default {
    components: {
        PostLabel,
        PostTag,
        PriceTag: PriceTag,
        ComboSlider: comboSlider,
        Loading: Loading,
        PagedQa: PagedQa,
        PagedInfos: PagedInfos,
        modalX: modalX,
        addToCart: addToCart,
        DualLink: DualLink,
        mediaLink: mediaLink
    },
    computed: {
        apiClient: function () {
            return this.mxnAgxApi.detailApiClient;
        },
        currency: function () {
            return this.$store.getters.configs.currency;
        },
        itemPageMsgs: function () {
            var shopNews = this.$store.getters.configs.shopNews;
            if (shopNews !== null && shopNews.length > 0) {
                return shopNews.filter((news) => { return news.msgType === "1"; });
            }
            return [];
        },
        lang: function () {
            return this.$store.getters.lang;
        },
        hasLogin: function () {
            return this.$store.getters.account !== null;
        },
        videos: function () {
            if (this.item && this.item.links !== null) {
                return this.item.links.filter((it) => { return it.linkType === 1 });
            }
            return [];
        },
        links: function () {
            if (this.item && this.item.links !== null) {
                return this.item.links.filter((it) => { return it.linkType === 0 });
            }
            return [];
        },
        hasPrice: function () {
            return (this.item && this.item.prices && this.item.prices.length > 0);
        }
    },
    props: ["postId"],
    filters: {

    },
    methods: {
        showDetail: function () {
            this.inView = "detail";
            this.html = this.item.textMsg;
        },
        showLabels: function () {
            this.inView = "label";
            var $that = this;
            $that.isLoading = true;
            this.apiClient.getPostCatLabelsPrms($that.postId).done(function (data) {
                $that.isLoading = false;
                $that.html = data.responseText;
            });
        },
        showTags: function () {
            this.inView = "tag";
            var $that = this;
            $that.isLoading = true;
            this.apiClient.getPostTagsPrms($that.postId).done(function (data) {
                $that.isLoading = false;
                $that.html = data.responseText;
            });
        },
        loadItem: function () {
            var $that = this;
            $that.isLoading = true;
            this.apiClient.getPostByIdPrms($that.postId).done(function (data) {
                $that.isLoading = false;
                $that.item = data;
                $that.html = data.textMsg;
                if (data.images !== null && data.images.length > 0) {
                    $that.sliderData = data.images.map((item, index) => {
                        return { path: item.path, link: "", msg: item.textContent };
                    });
                }
            });
        }
    },
    data: function () {
        return {
            item: null,
            html: "",
            sliderData: [],
            sliderLoaded: false,
            inView: "detail",
            isLoading: false,
            showAlert: false,
            alertMsg: "",
            showQa: false,
            showAddToCart: false
        }
    },
    mounted: function () {
        this.loadItem();
    },
    destroyed: function () {
    }

}
</script>